module.exports = __webpack_public_path__ + "static/img/news.0b661a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/news.jpg
// module id = FSY8
// module chunks = 1